import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import {
  MODAL_CLIENT_EDIT_CYCLE,
  MODAL_CLIENT_DELETE_CYCLE
} from 'redux/modules/modals'
import { tableTypesMatcher } from 'utils/labelMatcher'
import { getTableIcon } from 'utils/iconMatcher'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Avatar from '@material-ui/core/Avatar'
import AlarmIcon from '@material-ui/icons/Alarm'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import PricingSelectionComponent from 'components/pricing/PricingSelectionComponent'
import PlayersSelectionComponent from 'components/players/PlayersSelectionComponent'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  cycleAvatarLast: {
    color: 'white',
    backgroundColor: theme.palette.primary.main
  },
  cycleAvatar: {
    color: 'white',
    backgroundColor: theme.palette.disabled
  },
  lastCycleAvatar: {
    color: 'white',
    backgroundColor: theme.palette.primary.main
  },
  heading: {
    fontSize: theme.typography.pxToRem(15)
  },
  headingRunning: {
    fontSize: theme.typography.pxToRem(17)
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  details: {
    alignItems: 'center'
  },
  column: {
    flexBasis: '33.33%'
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  textField: {
    width: 220
  }
})

class CycleComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onExpand: PropTypes.func.isRequired,
    cycle: PropTypes.object.isRequired,
    pricings: PropTypes.array.isRequired,
    updateCyclePricing: PropTypes.func.isRequired,
    updateCyclePlayers: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
    index: PropTypes.number,
    count: PropTypes.number,
    expanded: PropTypes.bool,
    isLast: PropTypes.bool,
    total: PropTypes.string,
    elapsed: PropTypes.string
  }
  handleExpandChange = () => {
    this.props.onExpand(this.props.cycle.key)
  }
  handleEditClick = e => {
    this.props.showModal(MODAL_CLIENT_EDIT_CYCLE, this.props.cycle)
  }
  handleDeleteClick = e => {
    this.props.showModal(MODAL_CLIENT_DELETE_CYCLE, this.props.cycle)
  }
  componentDidMount() {
    this.setState({
      startDate: this.props.cycle.startDate,
      breakPeriod: this.props.cycle.breakPeriod
    })
  }
  handlePricingChange = pricing => {
    this.props.updateCyclePricing(this.props.index, pricing)
  }
  handlePlayersChange = (index, count) => {
    const players = [...this.props.cycle.players]
    players[index].count = count
    this.props.updateCyclePlayers(this.props.index, players)
  }
  render() {
    const {
      classes,
      isLast,
      expanded,
      index,
      cycle,
      pricings,
      count
    } = this.props
    return (
      <div className={classes.root}>
        <ExpansionPanel expanded={expanded} onChange={this.handleExpandChange}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="space-between">
              <Grid item>
                <Avatar
                  className={
                    isLast ? classes.cycleAvatarLast : classes.cycleAvatar
                  }>
                  <AlarmIcon color="inherit" />
                </Avatar>
              </Grid>
              <Grid item>
                <Typography
                  variant="body1"
                  className={classes.heading}>{`Cycle ${index +
                  1}`}</Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="body1"
                  className={classes.secondaryHeading}>
                  {`Tarif ${cycle.pricing.name}`}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="body1"
                  className={classes.secondaryHeading}>
                  {`${moment(cycle.startDate).format('DD/MM - HH:mm:ss')}`}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  variant="body1"
                  className={classes.secondaryHeading}>
                  {cycle.endDate
                    ? `${moment(cycle.endDate).format('DD/MM - HH:mm:ss')}`
                    : `Durée ( ${this.props.elapsed} )`}
                </Typography>
              </Grid>

              <Grid item>
                {!isLast &&
                  cycle.endDate && (
                    <Typography
                      variant="body1"
                      className={classes.secondaryHeading}>
                      {`${cycle.total.toFixed(2)} €`}
                    </Typography>
                  )}
                {isLast &&
                  this.props.total !== null && (
                    <Typography
                      variant="body1"
                      className={classes.secondaryHeading}>
                      {`${this.props.total} €`}
                    </Typography>
                  )}
              </Grid>
            </Grid>
          </ExpansionPanelSummary>
          <Divider />
          <ExpansionPanelDetails className={classes.details}>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="space-around">
              <Grid item xs={6}>
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  justify="space-between">
                  <Grid
                    item
                    xs={6}
                    container
                    direction="row"
                    alignItems="center"
                    justify="flex-start"
                    spacing={0}>
                    <Grid item>{getTableIcon(cycle.tableType, 'primary')}</Grid>
                    <Grid item>
                      <Typography
                        variant="subheading"
                        style={{ marginLeft: 10 }}
                        gutterBottom>
                        {tableTypesMatcher(cycle.tableType)}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <PricingSelectionComponent
                      className={classes.textField}
                      selectedPricing={cycle.pricing}
                      pricings={pricings}
                      onChange={this.handlePricingChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      id="start-date-local"
                      label="Date de début"
                      type="datetime-local"
                      className={classes.textField}
                      value={moment(cycle.startDate).format(
                        'YYYY-MM-DDTHH:mm:ss'
                      )}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 1 // seconds
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      disabled
                      id="time"
                      label="Temps de pause"
                      type="time"
                      value={`${moment
                        .utc(cycle.breakPeriod)
                        .format('HH:mm:ss')}`}
                      className={classes.textField}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 1 // seconds
                      }}
                    />
                  </Grid>
                  {cycle.endDate ? (
                    <Grid item xs={12}>
                      <TextField
                        disabled
                        id="end-date-local"
                        label="Date de fin"
                        type="datetime-local"
                        className={classes.textField}
                        value={moment(cycle.endDate).format(
                          'YYYY-MM-DDTHH:mm:ss'
                        )}
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{
                          step: 1 // seconds
                        }}
                      />
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item>
                <PlayersSelectionComponent
                  mini
                  players={cycle.players}
                  onChange={this.handlePlayersChange}
                />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <Button
              onClick={this.handleDeleteClick}
              size="small"
              disabled={count === 1}>
              Supprimer
            </Button>
            <Button onClick={this.handleEditClick} size="small" color="primary">
              Editer
            </Button>
          </ExpansionPanelActions>
        </ExpansionPanel>
      </div>
    )
  }
}

export default withStyles(styles)(CycleComponent)



// WEBPACK FOOTER //
// ./src/routes/Table/components/CycleComponent.js